"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kx = require("@/api/kx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'KxAgent',
  data: function data() {
    return {
      activeTab: 'agent',
      agentLoading: false,
      agentList: {
        data: [],
        total: 0
      },
      agentSearch: {
        uid: '',
        uidPhone: '',
        page: 1,
        limit: 20
      },
      perfLoading: false,
      perfList: {
        data: [],
        total: 0
      },
      perfSearch: {
        uid: '',
        uidPhone: '',
        yearMonth: '',
        page: 1,
        limit: 20
      }
    };
  },
  mounted: function mounted() {
    this.getAgentList();
  },
  methods: {
    handleTabClick: function handleTabClick() {
      if (this.activeTab === 'agent') this.getAgentList(1);else this.getPerformanceList(1);
    },
    // 代理列表
    getAgentList: function getAgentList(num) {
      var _this = this;
      this.agentLoading = true;
      this.agentSearch.page = num || this.agentSearch.page;
      (0, _kx.kxAgentListApi)(this.agentSearch).then(function (res) {
        _this.agentList.data = res.list || [];
        _this.agentList.total = res.total || 0;
        _this.agentLoading = false;
      }).catch(function () {
        _this.agentLoading = false;
      });
    },
    handleCancel: function handleCancel(uid) {
      var _this2 = this;
      (0, _kx.kxAgentCancelApi)({
        uid: uid
      }).then(function () {
        _this2.$message.success('已取消代理');
        _this2.getAgentList();
      });
    },
    agentPageChange: function agentPageChange(page) {
      this.agentSearch.page = page;
      this.getAgentList();
    },
    handleAgentSizeChange: function handleAgentSizeChange(val) {
      this.agentSearch.limit = val;
      this.getAgentList();
    },
    // 团队业绩
    getPerformanceList: function getPerformanceList(num) {
      var _this3 = this;
      this.perfLoading = true;
      this.perfSearch.page = num || this.perfSearch.page;
      (0, _kx.kxAgentPerformanceApi)(this.perfSearch).then(function (res) {
        _this3.perfList.data = res.list || [];
        _this3.perfList.total = res.total || 0;
        _this3.perfLoading = false;
      }).catch(function () {
        _this3.perfLoading = false;
      });
    },
    handleExport: function handleExport() {
      var _this4 = this;
      (0, _kx.kxAgentPerformanceExportApi)({
        uid: this.perfSearch.uid,
        uidPhone: this.perfSearch.uidPhone,
        yearMonth: this.perfSearch.yearMonth
      }).then(function (res) {
        if (res && res.fileName) {
          _this4.$message.success('导出成功，文件名: ' + res.fileName);
        }
      });
    },
    perfPageChange: function perfPageChange(page) {
      this.perfSearch.page = page;
      this.getPerformanceList();
    },
    handlePerfSizeChange: function handlePerfSizeChange(val) {
      this.perfSearch.limit = val;
      this.getPerformanceList();
    }
  }
};